import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { take } from "rxjs/operators";
import { BaseModalComponent } from "../base-modal/base-modal.component";
import { StarLineItemComponent } from "../star-line-item/star-line-item.component";
import { SS02SuperStarsQuickAddService } from "@app/services/onboarding-lessons/ss02-super-stars-quick-add.service";

@Component({
  selector: "app-dialog-super-stars",
  templateUrl: "./dialog-super-stars.component.html",
  styleUrls: ["./dialog-super-stars.component.scss"],
  standalone: true,
  imports: [CommonModule, BaseModalComponent, StarLineItemComponent],
})
export class DialogSuperStarsComponent implements OnInit, OnDestroy {
  stars: string[];

  constructor(
    public dialogRef: MatDialogRef<DialogSuperStarsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string[],
    private ss02QuickAdd: SS02SuperStarsQuickAddService
  ) {
    this.stars = data;
  }

  ngOnInit(): void {
    // Onboarding SS02 "Super Stars quick-add" (FLIP-372) - an anchored prompt at the first Star's +,
    // the first time this modal opens after SS01. Self-gates; nothing to point at without a Star.
    // Only once the open animation has finished: mid-animation the dialog is still scaled and
    // sliding in, so the + would be measured well above where it lands and the prompt left there.
    if (this.stars?.length) {
      this.dialogRef
        .afterOpened()
        .pipe(take(1))
        .subscribe(() => this.ss02QuickAdd.onDialogOpened());
    }
  }

  ngOnDestroy(): void {
    this.ss02QuickAdd.onDialogClosed();
  }

  closeWithStar(star: string): void {
    this.ss02QuickAdd.onStarSelected();
    this.dialogRef.close(star);
  }

  close() {
    this.dialogRef.close();
  }
}
